import { SubService, ApiResponse, SubServiceFormData } from "../types";
import { apiClient } from "./apiClient";

export const subServicesApi = {
  // Get all subservices by company
  async getSubServicesByCompany(): Promise<ApiResponse<SubService[]>> {
    try {
      const data = await apiClient.get<any>(
        `/subservices`
      );

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Get subservice by ID
  async getSubServiceById(id: number): Promise<ApiResponse<SubService>> {
    try {
      const data = await apiClient.get<any>(`/subservices/${id}`);

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Create a new subservice
  async createSubService(
    subServiceData: SubServiceFormData
  ): Promise<ApiResponse<SubService>> {
    try {
      const payload = {
        ...subServiceData,
        isActive: true,
      };

      const data = await apiClient.post<any>("/subservices", payload);

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Update an existing subservice
  async updateSubService(
    id: number,
    subServiceData: Partial<SubServiceFormData>
  ): Promise<ApiResponse<SubService>> {
    try {
      const data = await apiClient.put<any>(
        `/subservices/${id}`,
        subServiceData
      );

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Delete a subservice (soft delete by setting isActive to false)
  async deleteSubService(id: number): Promise<ApiResponse<void>> {
    try {
      await apiClient.delete(`/subservices/${id}`);

      return {
        success: true,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Toggle subservice active status
  async toggleSubServiceStatus(
    id: number,
    isActive: boolean
  ): Promise<ApiResponse<SubService>> {
    try {
      const data = await apiClient.patch<any>(
        `/subservices/${id}/toggle-status`,
        { isActive }
      );

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};

export default subServicesApi;
